





























































import Vue from "vue";
import Bus from "./modules/activity/common/bus";
import { isLogin } from "./modules/activity/common/common";
import { roteJoin } from "./modules/activity/common/api";
import Rote from "./modules/activity/components/rote/Rote.vue";
import Person from "./modules/activity/components/person/Preson.vue";
import Navigation from "./modules/activity/components/Navigation/Navigation.vue";
import Pixel from "@/service/pixel";
Pixel.instance.init({
  id: {
    fb: CONFIG["data"].fb,
    ga: CONFIG["data"].ga
  }
});
import {
  reserveInfo,
  reserveJoin,
  loginWithFB,
  roteInfo
} from "./modules/activity/common/api";

declare var CONFIG: Object;
declare var player: any;
declare var YT: any;
declare var FB: any;
declare var onPlayerReady: any;
declare var onPlayerStateChange: any;

export default Vue.extend({
  components: {
    Rote,
    Person,
    Navigation
  },
  data() {
    return {
      test: CONFIG,
      anima: true,
      userIsLogin: false,
      isSearch: false,
      isVideo: false,
      egPhone: "0912345678",
      userPhone: "", //玩家手机号
      reservePerson: "", //当前预约人数
      bottomTxt: [
        "Điền SĐT tham gia event đặt gạch",
        "Đặt gạch thành công và đăng nhập FB sẽ có 1 cơ hội rút thưởng",
        "Chia sẻ event lên trang FB cá nhân có thêm 1 cơ hội rút thưởng",
        "Mỗi bạn mỗi ngày tối đa nhận được 2 cơ hội rút thưởng",
        "Quà đặt gạch sẽ gửi qua SMS sau khi game ra mắt",
        "Quà vòng quay được gửi ngay sau khi rút",
        "User rút trúng iPhone XR phải điền thông tin theo yêu cầu để tiện phát thưởng:",
        "Chúng tôi không chịu trách nhiệm trong trường hợp user cung cấp thông tin sai dẫn đến không thể liên lạc",
        "Tam Quốc Bùm Chíu 2 sẽ bổ sung nội dung quyền lợi trong phạm vi pháp luật cho phép"
      ]
    };
  },
  async created() {
    // YouTube视频脚本加载
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag: any = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    // 获取预约人数
    let data: any = await reserveInfo();
    if (data && data.code == 200) {
      this.reservePerson = data.state.countTimes.toString();
    }
    if (isLogin()) {
      this.userIsLogin = true;
      let val = await roteInfo();
      // if (val) {
      //   console.log(val);
      // }
    }
    Bus.$on("loginSuccess", target => {
      // console.log(target);
      this.userIsLogin = target;
    });
  },
  methods: {
    // fbcebook登录
    async facebook() {
      if (isLogin()) {
        location.reload();
        localStorage.clear();
        return;
      }
      let that = this;
      FB.getLoginStatus(function(response) {
        if (response.status === "connected") {
          that.FBSdkLogin(response.authResponse.accessToken);
        } else {
          FB.login(function(response) {
            if (response.status === "connected") {
              // Logged into your app and Facebook.
              that.FBSdkLogin(response.authResponse.accessToken);
            } else {
              // The person is not logged into this app or we are unable to tell.
            }
          });
        }
      });
    },
    async FBSdkLogin(token) {
      let data: any = await loginWithFB(token);
      if (data && data.code == 200) {
        localStorage.setItem("token", data.state.token);
        let myTimer: any = new Date().getTime().toString();
        localStorage.setItem("activetime", myTimer);
        this.userIsLogin = true;
        // console.log(data);
        let result: any = await roteInfo();
        result && result.code == 200;
      }
    },
    //手机号输入验证
    inputPhone() {
      if (this.userPhone.length == 1) {
        this.userPhone = this.userPhone.replace(/[^0-9]/g, "");
      } else {
        this.userPhone = this.userPhone.replace(/\D/g, "");
      }
    },
    // 获得焦点
    inputFocus() {
      if(!isLogin()){
        Vue.prototype.$dialog.show("tip", CONFIG["tip"].code_300, true);
        return;
      }
      this.egPhone = "";
    },
    // 失去焦点
    inputBlur() {
      if (!this.userPhone) {
        this.egPhone = "0912345678";
      }
    },
    //注销
    dropOut() {
      localStorage.clear();
      location.reload();
    },
    //video
    onPlayerReady(event) {
      event.target.playVideo();
    },
    onPlayerStateChange(event) {
      var done = false;
      if (event.data == YT.PlayerState.PLAYING && !done) {
        done = true;
      }
    },
    stopVideo() {
      player.stopVideo();
    },
    closeVideo() {
      this.isVideo = false;
    },
    videoBtn() {
      this.isVideo = true;
      var player = new YT.Player("player", {
        width: "640",
        height: "360",
        videoId: "IEy15GcdZHk",
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange
        }
      });
    },
    loginBtn() {},
    //点击预约
    async reserveBtn() {
      var testphone = /^[0-9]*$/;
      if (!this.userPhone) {
        Vue.prototype.$dialog.show("tip", CONFIG["tip"].phone_null);
        return;
      } else if (this.userPhone.length < 10) {
        Vue.prototype.$dialog.show("tip", CONFIG["tip"].phone_null);
        this.userPhone = "";
        return;
      } else {
        let phone = "084" + "-" + this.userPhone;
        let data: any = await reserveJoin(phone);
        if (data && data.code == 200) {
          // 存储手机号
          let reservePhone = "phone,"+phone;
          let rest =  await roteJoin(reservePhone);
          console.log('>>>>>>>>>', reservePhone,rest)
          // reserver pixel
          Pixel.instance.pixel("button");
          let number: any = Number(this.reservePerson);
          this.reservePerson = (number + 1).toString();
          if (isLogin()) {
            Vue.prototype.$dialog.show(
              "tip",
              CONFIG["tip"].reserve_success_login
            );
            return;
          }
          Vue.prototype.$dialog.show(
            "tip",
            CONFIG["tip"].reserve_success,
            true
          );
          
        } else if (data && data.code == 1005) {
          Vue.prototype.$dialog.show("tip", CONFIG["tip"].code_1005);
        } else {
          this.userPhone = "";
        }
      }
    },
  }
});
